import { render, staticRenderFns } from "./PostRow.vue?vue&type=template&id=7a3841a5&scoped=true"
import script from "./PostRow.vue?vue&type=script&lang=js"
export * from "./PostRow.vue?vue&type=script&lang=js"
import style0 from "./PostRow.vue?vue&type=style&index=0&id=7a3841a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3841a5",
  null
  
)

export default component.exports